import React from 'react';
import { Helmet } from 'react-helmet';
import UI_UX from './UI_UX';

const UIUXPage = () => (
  <>
    <Helmet>
      <title>UI/UX Design Solutions | MilaajBrandset</title>
      <meta
        name="description"
        content="Enhance user experiences with MilaajBrandset's UI/UX design solutions. Discover our approach to creating intuitive and engaging user interfaces that drive results."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, UI design, UX design, user experience, user interface, design solutions, interactive design"
      />
      <meta property="og:title" content="UI/UX Design Solutions | MilaajBrandset" />
      <meta
        property="og:description"
        content="Enhance user experiences with MilaajBrandset's UI/UX design solutions. Discover our approach to creating intuitive and engaging user interfaces that drive results."
      />
    </Helmet>
    <UI_UX />
  </>
);

export default UIUXPage;